/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Error_Too_Many_RendersInputs */

const en_directory_ai_tools_error_too_many_renders = /** @type {(inputs: Directory_Ai_Tools_Error_Too_Many_RendersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have two videos rendering. Wait for one to finish.`)
};

const zh_directory_ai_tools_error_too_many_renders = /** @type {(inputs: Directory_Ai_Tools_Error_Too_Many_RendersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已有两条视频正在生成，请等其中一条完成。`)
};

/**
* | output |
* | --- |
* | "You already have two videos rendering. Wait for one to finish." |
*
* @param {Directory_Ai_Tools_Error_Too_Many_RendersInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_error_too_many_renders = /** @type {((inputs?: Directory_Ai_Tools_Error_Too_Many_RendersInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Error_Too_Many_RendersInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_error_too_many_renders(inputs)
	return zh_directory_ai_tools_error_too_many_renders(inputs)
});
export { directory_ai_tools_error_too_many_renders as "directory.ai_tools.error.too_many_renders" }